// extracted by mini-css-extract-plugin
module.exports = {"mButton":"m-button_mButton__2LJ21","fancy":"m-button_fancy__1UdPk"};